import React from 'react';
import { connect } from 'react-redux';
import { InfoBar } from 'ctia-ui';
import { getDeviceTitle } from 'helpers/DeviceTypeHelper';
import { getStatusTitle, isEco } from 'helpers/RequestHelper';

const EcoInfoBar = ({ request }) => {
  const { status, vendor, modelName, deviceType, type } = request;

  if (!isEco(type)) return null;

  const reqDataInfo = [
    {
      key: 'Status',
      value: getStatusTitle(status)
    },
    {
      key: 'Manufacturer',
      value: vendor
    },
    {
      key: 'Model Name/Number',
      value: modelName
    },
    {
      key: 'Device Type',
      value: getDeviceTitle(deviceType)
    }
  ];

  return <InfoBar show={!request.formSaved} data={reqDataInfo} />;
};

function mapStateToProps({ request }) {
  return { request };
}

export default connect(mapStateToProps)(EcoInfoBar);



// WEBPACK FOOTER //
// ./src/containers/request/Initial/EcoInfoBar.js